import { render, staticRenderFns } from "./address.vue?vue&type=template&id=cad4ffb8&scoped=true&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"
import style0 from "./address.vue?vue&type=style&index=0&id=cad4ffb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad4ffb8",
  null
  
)

export default component.exports